import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";
import {LocationSchemaModel} from "./location-schema-model";
import {CompetitionLogoParams} from "../../../domain/common/competition/models/competition-logo-params";

export class SportOrganizationSchemaDataModel extends BaseSchemaDataModel {
  id: Number;
  sport: String;
  location: LocationSchemaModel;
  logo: CompetitionLogoParams;
}

export class SportOrganizationSchemaModel extends BaseSchemaModel {
  model: SportOrganizationSchemaDataModel;

  constructor(model: SportOrganizationSchemaModel) {
    super(SCHEMA_TYPE.sportsOrganization, model.name, model.url);

    this.model = model;
  }

  get sportParams(): String {
    return this.model.sport ? `,"sport": "${this.model.sport}"` : '';
  }

  get logoParams(): String {
    return this.model.logo ? `,"logo": "${this.model.logo.toString()}"` : '';
  }

  get locationParams(): String {
    return this.model.location ? `,"location": [${this.model.location.toString()}]` : '';
  }

  toString(): String {
    return `${super.toString()}${this.sportParams}${this.logoParams}${this.locationParams}`;
  }
}
